import React from 'react';
import ReactTooltip from 'react-tooltip';

import { useActiveScene } from 'js/shared/hooks/useActiveScene';

import OptionMenuButton from './OptionMenuButton';
import { useAnimationStageContext } from './AnimationStageContext';

import './DirectionMenu.css';

const TOOLTIP_ID = 'direction-tooltip';

const DirectionMenu = () => {
  const { directionMenuOptions, getSelectedDirectionChoice, onDirectionChoice } = useAnimationStageContext();

  const activeScene = useActiveScene();

  if (!activeScene) {
    return null;
  }

  const selected = getSelectedDirectionChoice();

  return (
    <div className="DirectionMenu">
      <div className="DirectionMenu__Grid">
        {directionMenuOptions.map(dir => {
          const { Icon } = dir;
          if (dir.label === 'Scene Thumbnail') {
            return (
              <div key={dir.label} className="DirectionMenu__SceneContainer">
                <img className="DirectionMenu__SceneTile" src={activeScene.thumbnailImage} alt={dir.label} />
              </div>
            );
          }

          const handleOptionClick = () => {
            onDirectionChoice(dir);
          };

          return (
            <OptionMenuButton
              key={dir.label}
              selected={selected.label === dir.label}
              onClick={handleOptionClick}
              tooltipProps={{
                'data-tip': dir.label,
                'data-for': TOOLTIP_ID
              }}
            >
              {Icon && <Icon />}
            </OptionMenuButton>
          );
        })}
      </div>
      <ReactTooltip id={TOOLTIP_ID} className="t-utility-label" />
    </div>
  );
};

export default DirectionMenu;
